import { getHours, getMinutes, addMinutes } from 'date-fns';

export const getMinutesFromHour = (date: Date): number => {
  return getMinutes(date) + getHours(date) * 60;
};

const roundToNearestInterval = (value: number, interval: number): number => {
  return Math.round(value / interval) * interval;
};

export const getStartDateTime = (date: Date, minutes: number, interval: number): Date => {
  const val = roundToNearestInterval(minutes, interval);
  const startAt = new Date(date.toDateString());
  return addMinutes(startAt, val);
};
